import { ChartSettingsT, ChartT, VizType } from 'business/definitions';
import { useMutation } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import { useDispatch } from 'store/hooks';
import { useSettingsDispatchContext } from '../components/Contexts/SettingsContext/SettingsContext';
import { useNavigate } from 'react-router-dom';

export type ChartDataT = {
    metrics: QueryMetricT[];
    dimensions: QueryDimensionT[];
    filters: QueryFilterT[];
    vizType: VizType;
    title: string;
    settings: ChartSettingsT;
};

export const useUpdateChartThenUpdateVizSettings = (
    shouldShowSuccessMessage: boolean = true,
) => {
    const navigate = useNavigate();
    const { updateVizSettings } = useSettingsDispatchContext();
    const dispatch = useDispatch();
    const mutation = useMutation({
        mutationFn: (payload: {
            chartData: Partial<ChartT> | Partial<ChartDataT>;
            chartKey: number;
            redirect: boolean;
            dashboardSlug: string | undefined;
            onSuccess?: () => void;
        }) => {
            const { chartData, chartKey } = payload;

            return RQAPICallWithData<{ key: number }>({
                endpoint: `explore/chart/${chartKey}`,
                method: 'PUT',
                body: chartData,
            });
        },

        onSuccess: (
            response,
            { chartData, redirect, dashboardSlug, chartKey, onSuccess },
        ) => {
            if (shouldShowSuccessMessage) {
                dispatch.vision.notifyUser({
                    message: response.content.message,
                    snackType: 'info',
                });
            }
            updateVizSettings({ title: chartData.title });
            if (onSuccess) onSuccess();
            if (redirect && dashboardSlug) {
                navigate(`/dashboard/${dashboardSlug}#grid-chart-${chartKey}`);
            }
        },
    });
    return {
        updateChartThenUpdateVizSettings: mutation.mutate,
        isUpdating: mutation.isPending,
    };
};
